export default function duration(seconds) {
  const date = new Date(null)
  date.setSeconds(seconds)
  return date.toISOString().substr(14, 5).replace(/^0/, '')
}
